module.exports = __webpack_public_path__ + "img/3.4eaf7f9c.png";